import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as svc from "../../api/stockService";
import { getApiErrorMessage } from "../../utils/apiError";

export const fetchCurrentStock = createAsyncThunk("stock/fetchCurrent", async (params) => {
  const res = await svc.getCurrentStock(params);
  return res.data;
});

export const fetchStockAdjustments = createAsyncThunk("stock/fetchAdjustments", async (params) => {
  const res = await svc.getStockAdjustments(params);
  return res.data;
});

export const createStockAdjustmentThunk = createAsyncThunk("stock/createAdjustment", async (data, { rejectWithValue }) => {
  try {
    await svc.createStockAdjustment(data);
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to create stock adjustment."));
  }
});

export const updateStockAdjustmentThunk = createAsyncThunk("stock/updateAdjustment", async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await svc.updateStockAdjustment(id, data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to update stock adjustment."));
  }
});

export const deleteStockAdjustmentThunk = createAsyncThunk("stock/deleteAdjustment", async (id, { rejectWithValue }) => {
  try {
    await svc.deleteStockAdjustment(id);
    return id;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to delete stock adjustment."));
  }
});

const stockSlice = createSlice({
  name: "stock",
  initialState: { currentStock: [], adjustments: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrentStock.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchCurrentStock.fulfilled, (state, action) => { state.loading = false; state.currentStock = action.payload; })
      .addCase(fetchCurrentStock.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(fetchStockAdjustments.pending, (state) => { state.loading = true; })
      .addCase(fetchStockAdjustments.fulfilled, (state, action) => { state.loading = false; state.adjustments = Array.isArray(action.payload) ? action.payload : []; })
      .addCase(fetchStockAdjustments.rejected, (state) => { state.loading = false; })
      .addCase(deleteStockAdjustmentThunk.fulfilled, (state, action) => {
        state.adjustments = state.adjustments.filter(
          (a) => (a.adjustmentID ?? a.id) !== action.payload
        );
      });
  },
});

export default stockSlice.reducer;
